// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-sidebar {
  height: 50%;
}

.loader {
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

.container {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 70vh;
  justify-content: center;
  align-items: center;
  margin-bottom: 55vh;
  margin-left: 0vw;
  overflow: hidden;
}

.consumerxlogo {
  width: 20vw;
}

.loader {
  height: 4px;
  width: 100%;
  --c:no-repeat linear-gradient(#424363 0 0);
  background: var(--c), var(--c), #0CAD99;
  background-size: 60% 100%;
  animation: l16 3s infinite;
}

@keyframes l16 {
  0% {
    background-position: -150% 0, -150% 0;
  }
  66% {
    background-position: 250% 0, -150% 0;
  }
  100% {
    background-position: 250% 0, 250% 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./src/app/rx-auth/auth-screen/auth-screen.component.scss","webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAeA;EAEE,WAAA;ACfF;;ADmBA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AChBF;;ACVA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;AFYF;AEVE;EACE,4BAAA;AFYJ;AEVI;EACE,YAAA;AFYN;;ACxBA,sBAAA;AEME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;AHsBJ;AGnBM;EACE,sHAAA;AHqBR;AGjBI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;AHmBN;AGhBI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;AHkBN;AGfI;EACE,mBAAA;EACA,sBAAA;AHiBN;;AGVE;EACE,qCAAA;AHaJ;AGVE;EACE,0BAAA;AHYJ;;AGNE;EACE,0BAAA;AHSJ;AGNE;EACE,uFAAA;AHQJ;;AIrEA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;AJsEA;;AInEA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;AJsEJ;;AIlEA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;AJmEJ;;AI9DA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AJ+BR;;AIzBA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;AJoFb;;AIvBA;EAAa,YAAA;AJ2Bb;;AI1BA;EAAO,SAAA;EAAW,iDAAA;AJ+BlB;;AI5BA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AJ6BJ;AI3BI;EACI,YAAA;EACA,SAAA;AJ6BR;;AI1BA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AJ6BF;;AI1BA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AJ6BF;;AI1BA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AJ6Gb;AI3BI;EACI,cAnFK;AJgHb;;AIzBA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;AJwGf;AI1BE;EACE,cA/EW;AJ2Gf;;AIxBA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;AJ2BJ;;AA5KA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AA+KJ;;AA7KA;EACI,WAAA;AAgLJ;;AA5KA;EACI,WAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,yBAAA;EACA,0BAAA;AA+KJ;;AA7KE;EACE;IAAM,qCAAA;EAiLR;EAhLE;IAAM,oCAAA;EAmLR;EAlLE;IAAM,mCAAA;EAqLR;AACF","sourcesContent":["//app-alert {\n//    position: fixed;\n//    top: 60px;\n//    left: 0;\n//    right: 0;\n//    z-index: 999;\n//}\n//body, html {\n//    background-color: #3d4451;\n//    position:relative;\n//    margin:0;\n//    margin-top:30vh;\n//    width:100vw;\n//}\n\napp-sidebar{\n  //width: 100%;\n  height: 50%;\n  \n}\n\n.loader {\n  height:100vh;\n  width:100%;\n  display:flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rDNA-wrapper {\n  //width: 100%;\n  //height: 100%;\n}","@import '../../app.component.scss';\n@import '../../../styles.scss';\n\n.container {\n    display:flex;\n    flex-direction: column;\n    width:100vw;\n    height:70vh;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 55vh;\n    margin-left: 0vw;\n    overflow: hidden;\n}\n.consumerxlogo {\n    width:20vw;\n}\n\n\n.loader {\n    height: 4px;\n    width: 100%;\n    --c:no-repeat linear-gradient(#424363 0 0);\n    background: var(--c),var(--c), $theme-accent;\n    background-size: 60% 100%;\n    animation: l16 3s infinite;\n  }\n  @keyframes l16 {\n    0%   {background-position:-150% 0,-150% 0}\n    66%  {background-position: 250% 0,-150% 0}\n    100% {background-position: 250% 0, 250% 0}\n  }","/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
